import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { FundWalletRequest } from '../../models/fund-wallets.model';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class WalletService {
  constructor(private http: HttpClient) {}

  private readonly API = `${environment.api_url}/carteira`;

  getWalletByFund(cnpjFundo: string): Observable<FundWalletRequest[]> {
    return this.http.get<FundWalletRequest[]>(`${this.API}/GetCarteira/${cnpjFundo}`);
  }
}
